import React from "react";

export const GoldenLeafs = ({ className = "", style = {} }) => (
  <svg
    className={className}
    style={style}
    width="60"
    height="57"
    viewBox="0 0 60 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.69915 43.246C9.86471 42.0871 9.86375 39.1678 9.02979 34.9497M9.69915 12.1349C8.08598 14.9003 5.41273 22.2287 7.62508 29.4188C8.24805 31.4435 8.7029 33.2964 9.02979 34.9497M12.4646 30.8015C17.3412 27.2549 23.8381 16.5872 12.5143 1.50526C11.7838 0.532417 10.3502 0.491857 9.58229 1.43541C2.65179 9.95109 -5.38086 26.1904 9.02979 34.9497M8.31639 55.6904C9.70164 52.8385 12.2509 49.0818 15.9213 45.5635M47.0324 35.641C33.089 33.4959 22.6315 39.1314 15.9213 45.5635M15.9213 45.5635C14.7691 42.0255 14.2621 33.567 21.4522 28.0361C26.8552 23.9838 41.4951 19.6676 57.6375 33.9077C58.319 34.5089 58.4936 35.5049 58.0216 36.2815C52.5024 45.3616 38.0066 58.9472 17.9954 49.4682"
      stroke="url(#paint0_linear)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="13.472"
        y1="48.9905"
        x2="51.2043"
        y2="23.0369"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
    </defs>
  </svg>
);
